import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';


const NotFoundLayout = props => {
  return (
    <>
      <Header {...props} />      
    <section class="sites-section-1">
            <div class="container-fluid">
                <div class="row">
  
                        {props.children}
      
                </div>
            </div>
    </section>
      <Footer />
    </>
  );
};

export default NotFoundLayout;
